<template>
  <section id="gallery-section" class="uk-padding-large uk-padding-remove-left uk-padding-remove-right"
           v-if="call_to_action.list"
  >
    <div v-for="s in call_to_action.list" v-bind:key="s.id">
      <div class="uk-container uk-container-large uk-margin-large-top uk-margin-medium-bottom">
        <h3 class="uk-align-center uk-width-2-3@l">Bildergalerie</h3>
      </div>
      <div id="gallery" class="uk-position-relative uk-visible-toggle uk-light"
           v-bind:key="s.id" data-uk-slider
           data-uk-lightbox="toggle: a.lightbox-toggle; animation: scale; pause-on-hover: true;">
        <ul class="uk-slider-items">
          <li v-for="(sliderImage, sliderIdx) in s.gallery" v-bind:key="sliderIdx"
              v-bind:style="{ width: sliderImage.width + 'px' }">
            <div class="uk-panel uk-margin-small-right">
              <div class="uk-position-relative">
                <template v-for="(image, imageIdx) in sliderImage.variations">
                  <img v-bind:key="imageIdx"
                       v-if="image.height === 385" v-bind:src="image.httpUrl" v-bind:alt="image.description"
                       v-bind:width="image.width" v-bind:height="image.height"
                  >
                  <a v-bind:key="imageIdx"
                     class="uk-icon-button uk-preserve-color lightbox-toggle"
                     v-else-if="image.width === 1920" v-bind:href="image.httpUrl"
                     data-uk-icon="icon: expand; ratio: 2;"
                  ></a>
                </template>
              </div>
            </div>
          </li>
        </ul>

        <a class="uk-position-center-left" href="#" data-uk-slidenav-previous data-uk-slider-item="previous"></a>
        <a class="uk-position-center-right" href="#" data-uk-slidenav-next data-uk-slider-item="next"></a>

      </div>
    </div>
  </section>
</template>
<script>
import {CALL_TO_ACTION} from '../../constants/graphql'
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'

UIkit.use(Icons)

export default {
  name: 'gallery',
  data () {
    return {
      call_to_action: {},
      parent_path: 'has_parent=/website/home-spenden/'
    }
  },
  apollo: {
    call_to_action: {
      query: CALL_TO_ACTION,
      variables () {
        return {
          parentPath: this.parent_path
        }
      }
    }
  }
}
</script>
<style lang="scss">
  @import "../../assets/scss/variables";
  @import "../../assets/scss/mixins";

  $icon-button-size: 72px;
  #gallery-section {
    h3 {
      @include fontSize(35px);
    }
  }

  #gallery {
    .uk-slider-items {
      li {
        .uk-icon-button {
          position: absolute;
          right: 0;
          top: 0;
          visibility: hidden;
        }
        &:hover {
          .uk-icon-button {
            visibility: visible;
          }
        }
        [data-uk-icon] {
          color: white;
          margin-right: 1em;
          margin-top: 1em;
          &.uk-icon-button {
            width: $icon-button-size;
            height: $icon-button-size;
            background-color: $color-dark-blue;
            &:hover, &:focus {
              background-color: $color-medium-blue;
            }
            &:active {
              background-color: darken($color-medium-blue, 20%);
            }
          }
        }
        [data-uk-slidenav-previous],
        [data-uk-slidenav-next] {
          height: 100%;
          width: 10em;
          display: flex;
          align-items: center;
        }
        [data-uk-slidenav-previous] {
          justify-content: flex-start;
          padding-left: 1em;
        }
        [data-uk-slidenav-next] {
          justify-content: flex-end;
          padding-right: 1em;
        }
      }
    }
  }

  html.touchevents {
    #gallery {
      .uk-slider-items {
        li {
          max-width: 100vw;
          .uk-panel {
            display: flex;
            align-items: flex-end;
            height: 100%;
          }
          .uk-icon-button {
            top: unset;
            bottom: 1em;
            visibility: visible;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Global/Gallery.vue